// extracted by mini-css-extract-plugin
module.exports = {"artwork":"softened-artwork_artwork__jc0jg"};